import styled from 'styled-components';

export const SummaryItem = styled.li`
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 14px 16px;
`;
